import clsx from 'clsx';

import { Icon, IconButton } from '@atom/mui';
import colors from '@atom/styles/colors';

import classes from './mapDrawerContent.module.css';

interface Props {
  value: string;
  label: string;
  icon: any;
  activeView: string;
  setActiveView: (view: string) => void;
}

const NavigationIcon = ({
  value,
  label,
  icon,
  activeView,
  setActiveView,
}: Props) => {
  return (
    <div
      onClick={() => setActiveView(value)}
      className={clsx(
        classes.iconContainer,
        activeView === value && classes.active,
      )}
    >
      <IconButton
        iconStyle={{
          color: activeView === value ? colors.brand.blue : colors.neutral.gray,
        }}
      >
        <Icon>{icon}</Icon>
      </IconButton>
      <div className={classes.label}>{label}</div>
    </div>
  );
};

export default NavigationIcon;
